// @flow

import {
  call,
  select,
} from 'redux-saga/effects'

import {mapSelectors} from '../selectors'
import {moveCenterMap} from '../lib/moveCenterMap'

export function* moveMapByLocation(location:Location):Effect {
  const map: GoogleMap = yield select(mapSelectors.getGoogleMap)
  yield call(moveCenterMap, location.latitude, location.longitude, map)
  return map
}